import {
  FETCH_CREATE_ORGANISATION_REQUEST,
  FETCH_CREATE_ORGANISATION_SUCCESS,
  FETCH_CREATE_ORGANISATION_FALUIRE,
} from './createOrganisationTypes'

const initialState = {
  loading: false,
  isCreateOrgSuccess: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CREATE_ORGANISATION_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_CREATE_ORGANISATION_SUCCESS : return {
      ...state,
      isCreateOrgSuccess: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_CREATE_ORGANISATION_FALUIRE : return {
      ...state,
      loading: false,
      isCreateOrgSuccess: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
